package com.kinoshazam.data

import com.kinoshazam.DEVISE_ID
import com.kinoshazam.LANGUAGE
import com.kinoshazam.REFRESH_TOKEN
import com.kinoshazam.THEME
import com.kinoshazam.config.PlatformConfig
import com.kinoshazam.config.getPlatformConfig
import com.kinoshazam.model.AppLanguage
import com.kinoshazam.model.AppUpdate
import com.kinoshazam.model.Features
import com.kinoshazam.model.Profile
import com.kinoshazam.model.ThemeState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

class GlobalStateRepository(
    private val secureStorage: Storage,
    private val commonStorage: Storage,
) {

    var deviceId: String = getOrCreateDeviceId()
    val isAndroidTv: Boolean = false

    private val _themeState: MutableStateFlow<ThemeState> =
        MutableStateFlow(commonStorage.get<String>(THEME)?.let {
            ThemeState.fromName(it)
        } ?: ThemeState.SYSTEM)
    val themeState: StateFlow<ThemeState> = _themeState.asStateFlow()

    val platformConfig: PlatformConfig
        get() = getPlatformConfig()

    private val _appUpdate: MutableStateFlow<AppUpdate> = MutableStateFlow(AppUpdate())
    val appUpdate: StateFlow<AppUpdate> = _appUpdate.asStateFlow()

    private val _appLanguage: MutableStateFlow<AppLanguage> = MutableStateFlow(
        commonStorage.get<String>(LANGUAGE)?.let {
            AppLanguage.fromCode(it)
        } ?: AppLanguage.EN
    )
    val appLanguage: StateFlow<AppLanguage> = _appLanguage.asStateFlow()

    private val _features: MutableStateFlow<Features> = MutableStateFlow(Features())
    val features: StateFlow<Features> = _features.asStateFlow()

    private val _isAuthorized = MutableStateFlow<Boolean>(
        secureStorage.get<String>(REFRESH_TOKEN) != null
    )
    val isAuthorized: StateFlow<Boolean> = _isAuthorized.asStateFlow()

    private val _profile = MutableStateFlow<Profile?>(null)
    val profile: StateFlow<Profile?> = _profile.asStateFlow()

    fun setProfile(newProfile: Profile?) {
        _profile.value = newProfile
    }

    fun setUpdate(update: AppUpdate) {
        _appUpdate.value = update
    }

    fun setAuth(isAuth: Boolean) {
        _isAuthorized.value = isAuth
    }

    fun setTheme(theme: ThemeState) {
        _themeState.value = theme
    }

    fun setFeatures(features: Features) {
        _features.value = features
    }

    fun setAppLanguage(language: AppLanguage) {
        _appLanguage.value = language
    }

    @OptIn(ExperimentalUuidApi::class)
    private fun getOrCreateDeviceId(): String {
        return commonStorage.get<String>(DEVISE_ID) ?: run {
            val id = Uuid.random().toString()
            commonStorage.put<String>(DEVISE_ID, id)
            id
        }
    }
}